import React from "react";

/**
 * Offizielles Plantus-Logo (PNG, transparent).
 * - `variant="dark"`  → für dunkle Hintergründe (invertiert das Logo nach Weiß)
 * - `variant="light"` (Default) → grünes Original
 */
export const PlantusLogo = ({
  className = "",
  testId = "plantus-logo",
  size = "md",
  variant = "light",
}) => {
  const heights = {
    sm: "h-7",
    md: "h-9",
    lg: "h-14",
    xl: "h-20",
  };
  const isDark = variant === "dark";
  return (
    <img
      src="/logo-plantus.png"
      alt="Plantus"
      data-testid={testId}
      className={`${heights[size] || heights.md} w-auto select-none ${
        isDark ? "brightness-0 invert" : ""
      } ${className}`}
      draggable={false}
    />
  );
};

export const AppleLogo = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M16.365 1.43c0 1.14-.493 2.27-1.177 3.08-.744.9-1.99 1.57-2.987 1.57-.12 0-.23-.02-.3-.03-.16-1.06.353-2.12 1.03-2.9.85-.95 2.282-1.66 3.434-1.72.01.01.001.01 0 0Zm4.143 16.04c-.32.74-.47 1.07-.88 1.73-.58.92-1.4 2.07-2.42 2.08-.91.01-1.14-.59-2.37-.58-1.23.01-1.49.59-2.4.58-1.02-.01-1.79-1.05-2.37-1.97-1.62-2.55-1.79-5.55-.79-7.14.71-1.13 1.83-1.79 2.88-1.79 1.07 0 1.74.59 2.62.59.85 0 1.37-.59 2.61-.59.94 0 1.94.51 2.65 1.39-2.33 1.28-1.95 4.61.47 5.7Z" />
  </svg>
);

export const PlayLogo = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M4.5 3.5 18 12 4.5 20.5V3.5Z" fill="#34A853" />
    <path d="M4.5 3.5 14 13 18 12 4.5 3.5Z" fill="#FBBC04" />
    <path d="M4.5 20.5 14 11 18 12 4.5 20.5Z" fill="#EA4335" />
    <path d="M4.5 3.5 14 13 14 11 4.5 20.5V3.5Z" fill="#4285F4" />
  </svg>
);

export const ApkIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 3v12" />
    <path d="m7 10 5 5 5-5" />
    <path d="M5 21h14" />
  </svg>
);
